import React, { useState } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import { SaveOutlined } from '@ant-design/icons';
import { Button, Form, InputNumber, message, Row, Select, Spin } from 'antd';
import PropTypes from 'prop-types';
import { getactionMessages, getCommissionMessages, getModalMessages } from '../../constants/messages';
import { searchInString } from '../../utilities/util';
import { SaveCommissionPercentConfig, SaveCommissionProductsConfig } from './actions';

let commissionMessages = getCommissionMessages(),
	actionMessages = getactionMessages(),
	modalMessages = getModalMessages();

const messages = {
	...commissionMessages,
	...actionMessages,
	...modalMessages,
};

const AnnualConfigurations = ({ products, productsAnnual, commissionPercent }) => {
	const intl = useIntl();
	const [form] = Form.useForm();
	const [loading, setLoading] = useState(false);

	const productOptions = products.map((product) => ({
		key: product.id,
		value: product.id,
		label: `${product.code} - ${product.description}`,
	}));

	const handleSave = async () => {
		try {
			setLoading(true);
			const values = await form.validateFields();
			await SaveCommissionPercentConfig(commissionPercent.id, values.commissionPercent);
			await SaveCommissionProductsConfig(productsAnnual.id, values.commissionableProducts, productsAnnual.value);
			message.success(intl.formatMessage({ ...messages.saveConfigurationsSuccess }));
		} catch (error) {
			message.error(intl.formatMessage({ ...messages.saveConfigurationsError }));
		} finally {
			setLoading(false);
		}
	};

	return (
		<Spin spinning={loading}>
			<Form
				form={form}
				layout="vertical"
				initialValues={{
					commissionPercent: commissionPercent.value * 100,
					commissionableProducts: productsAnnual.value ? productsAnnual.value : null,
				}}
			>
				<Form.Item name="commissionPercent" label={intl.formatMessage({ ...messages.commissionPercent })}>
					<InputNumber
						min={0}
						max={100}
						precision={0}
						className="job-full-component"
						formatter={(value) => `${value}%`}
						parser={(value) => value.replace('%', '')}
					/>
				</Form.Item>
				<Form.Item
					name="commissionableProducts"
					label={intl.formatMessage({ ...messages.commissionableProducts })}
				>
					<Select
						showSearch
						mode="multiple"
						filterOption={(input, option) => searchInString(input, option.label)}
						options={productOptions}
					/>
				</Form.Item>
			</Form>
			<Row justify="end">
				<Button type="primary" onClick={() => handleSave()} icon={<SaveOutlined />}>
					{''}
					<FormattedMessage {...messages.save} />
				</Button>
			</Row>
		</Spin>
	);
};

AnnualConfigurations.propTypes = {
	products: PropTypes.array.isRequired,
	productsAnnual: PropTypes.object.isRequired,
	commissionPercent: PropTypes.object.isRequired,
};

export default AnnualConfigurations;
